import React from "react";
import styled from "styled-components";

interface CmtListItemProps {
  onClick(item: number): void;
  favoriteContent: string[];
}
const CmtListItem = (props: CmtListItemProps) => {
  return (
    <CmtItemSet>
      {props.favoriteContent.map((content, index) => (
        <li onClick={(e) => props.onClick(index)}>{content}</li>
      ))}
    </CmtItemSet>
  );
};

const CmtItemSet = styled.ul`
  padding: 0 15px;
  > li {
    padding: 30px 0;
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
    color: ${({ theme }) => theme.color.tertiary};
    font-size: 20px;
    font-weight: 500;
    text-align: center;
  }
`;

export default CmtListItem;
